import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Analytics, Dthc, GlobalNotifications, Intent } from '../../../Modules';
import { Loader } from '../../../Elements';
import NotFound from '../../../App/404';
import { commitMutation, graphql } from 'react-relay';
import {
  Card,
  Dropdown,
  Grid,
  Header,
  Icon,
  Image,
  Segment
} from 'semantic-ui-react';
import chatImage from '../../../../assets/chat.png';
import styles from '../../Event.scss';
import Formsy from 'formsy-react';
import '../../../../lib/stylesheets/SlideTransition.scss';
import TitleInput from '../TitleInput';
import RenameDocument from '../../../Document/RenameDocument';
import Share from './Share';

export default class EventWorkspaces extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      lastUploaded: new Date(),
      event: _.cloneDeep(this.props.node),
      error: !this.props.node,
      titleEditor: {
        open: false
      }
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.workspaceTitleChangeHandler = this.workspaceTitleChangeHandler.bind(
      this
    );
    this.updateWorkspaceTitle = this.updateWorkspaceTitle.bind(this);
    this.getAlreadySigned = this.getAlreadySigned.bind(this);
    this.transition = this.transition.bind(this);
    this.deleteWupload = this.deleteWupload.bind(this);
    this.deleteEstimate = this.deleteEstimate.bind(this);
    this.deleteInvoice = this.deleteInvoice.bind(this);
    this.deleteForm = this.deleteForm.bind(this);
    this.deleteMusicPlanner = this.deleteMusicPlanner.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.openTitleEditor = this.openTitleEditor.bind(this);
    this.closeTitleEditor = this.closeTitleEditor.bind(this);
  }

  componentWillMount() {
    if (!this.props.node && this.props.location.query.share_token) {
      this.addWorkspaceToSession();
    }
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillReceiveProps(nextProps) {
    // If adding/removing workspaces, update local copy
    if (
      nextProps.node.workspaces.edges.length !==
      this.props.node.workspaces.edges.length
    ) {
      this.setState({ event: _.cloneDeep(nextProps.node) });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  getAlreadySigned(contract) {
    let alreadySigned = 0;
    contract.contract_signature_blocks.edges.map(signatureBlock => {
      if (signatureBlock.node.signed_at) {
        ++alreadySigned;
      }
      return signatureBlock;
    });
    return alreadySigned;
  }

  transition(e, location) {
    this.props.router.push(location || '/');
  }

  addWorkspaceToSession() {
    this.setState({ error: false });
    const onCompleted = () => {
      this.props.relay.refetch(
        fragmentVariables => fragmentVariables,
        null,
        () => {
          this.setState({
            lastUploaded: new Date(),
            event: _.cloneDeep(this.props.node),
            error: !this.props.node
          });
        }
      );
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation WorkspacesComponent_addWorkspaceToSessionMutation(
        $input: AddWorkspaceToSessionInput!
      ) {
        addWorkspaceToSession(input: $input) {
          workspace {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.location.query;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  openTitleEditor(e, documentId, documentType, initialTitle) {
    this.setState({
      titleEditor: {
        open: true,
        documentId,
        documentType,
        initialTitle
      }
    });
  }

  closeTitleEditor() {
    this.setState({ titleEditor: { open: false } });
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  updateWorkspaceTitle(index) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update workspace title',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated workspace title',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-workspace-title');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_UpdateWorkspaceMutation(
        $input: UpdateWorkspaceInput!
      ) {
        updateWorkspace(input: $input) {
          workspace {
            id
            title
          }
        }
      }
    `;
    // eslint-disable-next-line camelcase
    const { id, title } = this.state.event.workspaces.edges[index].node;
    const optimisticResponse = {
      updateWorkspace: { workspace: { id, title } }
    };
    const environment = this.props.relay.environment;

    if (title !== this.props.node.workspaces.edges[index].node.title) {
      commitMutation(environment, {
        mutation,
        variables: {
          input: {
            id,
            title
          }
        },
        optimisticResponse,
        onCompleted,
        onError
      });
    }
  }

  deleteWupload(id, parentID) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete file',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully deleted file',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-wupload');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteWuploadMutation(
        $input: DeleteWuploadInput!
      ) {
        deleteWupload(input: $input) {
          deletedWuploadId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'wuploads'],
        deletedIDFieldName: 'deletedWuploadId',
        connectionKeys: [
          {
            key: 'WorkspacesContainer_wuploads',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  deleteEstimate(id, parentID, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete estimate',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted estimate',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-estimate');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteEstimateMutation(
        $input: DeleteEstimateInput!
      ) {
        deleteEstimate(input: $input) {
          deletedEstimateId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'estimates'],
        deletedIDFieldName: 'deletedEstimateId',
        connectionKeys: [
          {
            key: 'EventShowContainer_estimates',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  deleteInvoice(id, parentID, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete invoice',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted invoice',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-invoice');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteInvoiceMutation(
        $input: DeleteInvoiceInput!
      ) {
        deleteInvoice(input: $input) {
          deletedInvoiceId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'invoices'],
        deletedIDFieldName: 'deletedInvoiceId',
        connectionKeys: [
          {
            key: 'EventShowContainer_invoices',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  deleteContract(id, parentID, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete contract',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted contract',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-contract');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteContractMutation(
        $input: DeleteContractInput!
      ) {
        deleteContract(input: $input) {
          deletedContractId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'contracts'],
        deletedIDFieldName: 'deletedContractId',
        connectionKeys: [
          {
            key: 'EventShowContainer_contracts',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  deleteForm(id, parentID, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete form',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted form',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-form');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteFormMutation(
        $input: DeleteFormInput!
      ) {
        deleteForm(input: $input) {
          deletedFormId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'forms'],
        deletedIDFieldName: 'deletedFormId',
        connectionKeys: [
          {
            key: 'WorkspacesContainer_forms',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  deleteMusicPlanner(id, parentID, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete music list',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted music list',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-music-planner');
    };

    const mutation = graphql`
      mutation WorkspacesComponent_deleteMusicPlannerMutation(
        $input: DeleteMusicPlannerInput!
      ) {
        deleteMusicPlanner(input: $input) {
          deletedMusicPlannerId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['workspace', 'music_planners'],
        deletedIDFieldName: 'deletedMusicPlannerId',
        connectionKeys: [
          {
            key: 'WorkspacesContainer_music_planners',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  workspaceTitleChangeHandler(e, index) {
    const obj = _.cloneDeep(this.state);
    obj.event.workspaces.edges[index].node.title = e.target.value;
    this.setState(obj);
  }

  render() {
    const { titleEditor } = this.state;
    const { node: event, relay, viewer } = this.props;

    const DocumentSettingsMenu = ({
      deletable,
      deleteDocument,
      document,
      openTitleEditor
    }) =>
      <div className={styles.documentSettingsMenu}>
        <Dropdown
          floating
          basic
          icon='ellipsis vertical'
          onClick={e => e.stopPropagation()}
        >
          <Dropdown.Menu style={{ right: 0, left: 'auto' }}>
            <Dropdown.Item
              text='Rename'
              onClick={e =>
                openTitleEditor(
                  e,
                  document.id,
                  // eslint-disable-next-line no-underscore-dangle
                  document.__typename,
                  // eslint-disable-next-line no-underscore-dangle
                  document.__typename === 'Wupload'
                    ? document.name
                    : document.title
                )}
            />
            {deletable &&
              deleteDocument &&
              <Dropdown.Item
                text='Delete'
                className={styles.negative}
                onClick={deleteDocument}
              />}
          </Dropdown.Menu>
        </Dropdown>
      </div>;

    return (
      <div>
        {event &&
          <div>
            {titleEditor.open &&
              <RenameDocument
                documentId={titleEditor.documentId}
                documentType={titleEditor.documentType}
                initialTitle={titleEditor.initialTitle}
                onClose={this.closeTitleEditor}
                relay={relay}
              />}
            {event.workspaces.edges.map((workspace, index) =>
              <Grid
                padded
                verticalAlign='middle'
                key={workspace.id || index}
                style={{ paddingBottom: '4em' }}
                verticalAlign='top'
                stackable
              >
                <Grid.Row columns='equal'>
                  <Grid.Column>
                    {event.can_edit &&
                      <Formsy.Form className='ui form'>
                        <div className='ui transparent fluid massive'>
                          <Dthc
                            desktop={TitleInput}
                            mobile={TitleInput}
                            title={workspace.node.title}
                            onChange={e => {
                              this.workspaceTitleChangeHandler(e, index);
                            }}
                            commitUpdate={this.updateWorkspaceTitle.bind(
                              null,
                              index
                            )}
                            handleClickOutside
                          >
                            <div className={styles.title}>
                              {workspace.node.title}
                            </div>
                          </Dthc>
                        </div>
                      </Formsy.Form>}
                    {!event.can_edit &&
                      <div className={styles.title}>
                        {workspace.node.title}
                      </div>}
                  </Grid.Column>
                  <Grid.Column textAlign='right'>
                    <Share
                      workspace={workspace.node}
                      event={event}
                      relay={relay}
                      viewer={viewer}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Segment>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <Card.Group
                              itemsPerRow={4}
                              doubling
                              style={{ wordBreak: 'break-word' }}
                            >
                              {workspace.node.contracts.edges.map(contract =>
                                <Card
                                  onClick={e =>
                                    this.transition(
                                      e,
                                      `/docs/c/${contract.node.id}`
                                    )}
                                  className={styles.workspaceCard}
                                  color='green'
                                  key={contract.node.id}
                                >
                                  <DocumentSettingsMenu
                                    deletable={contract.node.editable}
                                    deleteDocument={() =>
                                      this.deleteContract(
                                        contract.node.id,
                                        workspace.node.id
                                      )}
                                    document={contract.node}
                                    openTitleEditor={this.openTitleEditor}
                                  />
                                  <Card.Content>
                                    <Card.Header className={styles.cardTitle}>
                                      {contract.node.title}
                                    </Card.Header>
                                    <Card.Meta>Contract</Card.Meta>
                                    <br />
                                    {contract.node.contract_signature_blocks
                                      .edges.length > 0 &&
                                      <div>
                                        {this.getAlreadySigned(
                                          contract.node
                                        ) ===
                                          contract.node
                                            .contract_signature_blocks.edges
                                            .length &&
                                          <Card.Meta>
                                            <em>All Parties Signed</em>
                                            <Icon
                                              name='check circle'
                                              color='green'
                                            />
                                          </Card.Meta>}
                                        {this.getAlreadySigned(
                                          contract.node
                                        ) !==
                                          contract.node
                                            .contract_signature_blocks.edges
                                            .length &&
                                          <Card.Meta>
                                            <em>
                                              Awaiting Signatures -{' '}
                                              {this.getAlreadySigned(contract.node)}/{contract.node.contract_signature_blocks.edges.length}{' '}
                                              Signed
                                            </em>
                                          </Card.Meta>}
                                      </div>}
                                    {contract.node.contract_signature_blocks
                                      .edges.length === 0 &&
                                      <Card.Meta>
                                        <em>No Signature Requested</em>
                                      </Card.Meta>}
                                  </Card.Content>
                                </Card>
                              )}
                              {workspace.node.estimates.edges.map(estimate =>
                                <Card
                                  onClick={e =>
                                    this.transition(
                                      e,
                                      `/docs/e/${estimate.node.id}`
                                    )}
                                  className={styles.workspaceCard}
                                  color='orange'
                                  key={estimate.node.id}
                                >
                                  <DocumentSettingsMenu
                                    deletable
                                    deleteDocument={() =>
                                      this.deleteEstimate(
                                        estimate.node.id,
                                        workspace.node.id
                                      )}
                                    document={estimate.node}
                                    openTitleEditor={this.openTitleEditor}
                                  />
                                  <Card.Content>
                                    <Card.Header className={styles.cardTitle}>
                                      {estimate.node.title}
                                    </Card.Header>
                                    <Card.Meta>Estimate</Card.Meta>
                                  </Card.Content>
                                </Card>
                              )}
                              {workspace.node.invoices.edges.map(invoice =>
                                <Card
                                  onClick={e =>
                                    this.transition(
                                      e,
                                      `/docs/i/${invoice.node.id}`
                                    )}
                                  className={styles.workspaceCard}
                                  color='blue'
                                  key={invoice.node.id}
                                >
                                  <DocumentSettingsMenu
                                    deletable
                                    deleteDocument={() =>
                                      this.deleteInvoice(
                                        invoice.node.id,
                                        workspace.node.id
                                      )}
                                    document={invoice.node}
                                    openTitleEditor={this.openTitleEditor}
                                  />
                                  <Card.Content>
                                    <Card.Header className={styles.cardTitle}>
                                      {invoice.node.title}
                                    </Card.Header>
                                    <Card.Meta>Invoice</Card.Meta>
                                  </Card.Content>
                                </Card>
                              )}
                              {workspace.node.forms.edges.map(form =>
                                <Card
                                  onClick={e =>
                                    this.transition(
                                      e,
                                      `/docs/f/${form.node.id}`
                                    )}
                                  className={styles.workspaceCard}
                                  color='yellow'
                                  key={form.node.id}
                                >
                                  <DocumentSettingsMenu
                                    deletable
                                    deleteDocument={() =>
                                      this.deleteForm(
                                        form.node.id,
                                        workspace.node.id
                                      )}
                                    document={form.node}
                                    openTitleEditor={this.openTitleEditor}
                                  />
                                  <Card.Content>
                                    <Card.Header className={styles.cardTitle}>
                                      {form.node.title}
                                    </Card.Header>
                                    <Card.Meta>Form</Card.Meta>
                                  </Card.Content>
                                </Card>
                              )}
                              {workspace.node.music_planners.edges.map(
                                musicPlanner =>
                                  <Card
                                    onClick={e =>
                                      this.transition(
                                        e,
                                        `/docs/m/${musicPlanner.node
                                          .id}/${musicPlanner.node.can_edit
                                          ? 'edit'
                                          : 'preview'}`
                                      )}
                                    className={styles.workspaceCard}
                                    color='yellow'
                                    key={musicPlanner.node.id}
                                  >
                                    <DocumentSettingsMenu
                                      deletable
                                      deleteDocument={() =>
                                        this.deleteMusicPlanner(
                                          musicPlanner.node.id,
                                          workspace.node.id
                                        )}
                                      document={musicPlanner.node}
                                      openTitleEditor={this.openTitleEditor}
                                    />
                                    <Card.Content>
                                      <Card.Header className={styles.cardTitle}>
                                        {musicPlanner.node.title}
                                      </Card.Header>
                                      <Card.Meta>Music List</Card.Meta>
                                    </Card.Content>
                                  </Card>
                              )}
                              {workspace.node.wuploads.edges.map(wupload =>
                                <Card
                                  onClick={() => {
                                    window.location = wupload.node.url;
                                  }}
                                  key={wupload.node.id}
                                  color='grey'
                                  className={styles.workspaceCard}
                                >
                                  <DocumentSettingsMenu
                                    deletable
                                    deleteDocument={this.deleteWupload.bind(
                                      null,
                                      wupload.node.id,
                                      workspace.node.id
                                    )}
                                    document={wupload.node}
                                    openTitleEditor={this.openTitleEditor}
                                  />
                                  <Card.Content>
                                    <Card.Header className={styles.cardTitle}>
                                      {wupload.node.name}
                                    </Card.Header>
                                    <Card.Meta>File Upload</Card.Meta>
                                  </Card.Content>
                                </Card>
                              )}
                            </Card.Group>
                            {workspace.node.contracts.edges.length === 0 &&
                              workspace.node.estimates.edges.length === 0 &&
                              workspace.node.invoices.edges.length === 0 &&
                              workspace.node.forms.edges.length === 0 &&
                              workspace.node.music_planners.edges.length ===
                                0 &&
                              workspace.node.wuploads.edges.length === 0 &&
                              <div
                                style={{ textAlign: 'center', padding: '2em' }}
                              >
                                <Image
                                  src={chatImage}
                                  style={{
                                    margin: '0 auto',
                                    marginBottom: '2em'
                                  }}
                                />
                                <p
                                  style={{
                                    color: 'rgba(0,0,0,0.65)',
                                    maxWidth: '600px',
                                    fontSize: '1.28rem',
                                    margin: '0 auto'
                                  }}
                                >
                                  This is a shared space where you can
                                  collaborate with your client, team, or other
                                  vendors. You can upload files or add estimates
                                  here and they&apos;ll be visible to the people
                                  you share this space with.
                                </p>
                              </div>}
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </div>}
        {!event &&
          <div>
            {this.state.error && <NotFound viewer={viewer} />}
            {!this.state.error && <Loader />}
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/Workspace/WorkspacesComponent.js